import { getLocale } from "@pb/utils/locale";
import errorHandler from '../errorHandler';
import shouldUseCaching from './shouldUseCaching';
const setArticleToCache = ({ praConfiguration, articleId, data }) => {
    const parsedData = [];
    const cacheEntryValidPeriodInMS = 900000; // exp in 15min
    const { ID, CACHE_ID } = praConfiguration;
    const locale = getLocale();
    const localizedCacheId = `${CACHE_ID}${locale}`;
    if (!praConfiguration || !articleId || !shouldUseCaching(ID)) {
        return;
    }
    const dataSet = {
        articleId,
        data,
        expires: Date.now() + cacheEntryValidPeriodInMS,
    };
    parsedData.push(dataSet);
    try {
        sessionStorage.setItem(localizedCacheId, JSON.stringify(parsedData));
    }
    catch (error) {
        errorHandler(error);
    }
};
export default setArticleToCache;
//# sourceMappingURL=setArticleToCache.js.map